export const INSTALLMENTS_DOWNPAYMENT_PARAM_NAME = 'installments-downpayment'
export const INSTALLMENTS_NUM_OF_INSTALLMENTS_PARAM_NAME =
  'installments-num-of-installments'
